import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { SiteLanguage, SiteTranslation } from '../interfaces/site-page';
import { CultureService } from '../culture/culture.service';

/// Whether an address is one of the Bangla pages: /bn and everything under it.
export function isBanglaUrl(url: string): boolean {
    return /^\/bn(?=$|[\/?#])/.test(String(url || ''));
}

/// The language of the page on screen - the page load's (CultureService: Bangla under /bn, or everywhere for a visitor who
/// chose it; English otherwise) - written onto <html lang> after every navigation, the server render's included, and the
/// language versions of the page shown, for the header's switch. A page that has versions (a SitePage, a blog post, the
/// home page) says so once it has them; every navigation starts with none.
@Injectable({
    providedIn: 'root'
})
export class SiteLanguageService {
    private readonly versions = new BehaviorSubject<SiteTranslation[]>([]);
    readonly translations$: Observable<SiteTranslation[]> = this.versions.asObservable();

    lang: SiteLanguage = 'en';

    constructor(router: Router, @Inject(DOCUMENT) private document: Document, culture: CultureService) {
        this.lang = culture.lang === 'bn' ? 'bn' : 'en';
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.versions.next([]);
            }
            else if (event instanceof NavigationEnd) {
                this.document.documentElement.setAttribute('lang', this.lang);
            }
        });
    }

    /// The versions of the page on screen, this one included.
    setTranslations(translations: SiteTranslation[]): void {
        this.versions.next((translations || []).filter(t => t && t.path));
    }
}
